import { render, staticRenderFns } from "./SendPlanModal.vue?vue&type=template&id=3718d992&scoped=true"
import script from "./SendPlanModal.vue?vue&type=script&lang=js"
export * from "./SendPlanModal.vue?vue&type=script&lang=js"
import style0 from "./SendPlanModal.vue?vue&type=style&index=0&id=3718d992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718d992",
  null
  
)

export default component.exports